var CONTAINER_ID = "root";
var createContainer = function(id) {
    var rootElement = document.createElement("div");
    rootElement.setAttribute("id", id);
    rootElement.classList.add("neru");
    document.body.appendChild(rootElement);
    return rootElement;
};
export var getContainer = function() {
    var id = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : CONTAINER_ID;
    var _document_getElementById;
    return (_document_getElementById = document.getElementById(id)) !== null && _document_getElementById !== void 0 ? _document_getElementById : createContainer(id);
};

//# sourceMappingURL=get-container.js.map